exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.cost-table td[data-v-627c38fb] {\n  padding: 10px 50px;\n}\n", ""]);

